import { Badge } from '@/components/ui/badge'
import type { GlossaryTermStatus } from '@/types/knowledge'

const statusConfig: Record<GlossaryTermStatus, { variant: 'succeeded' | 'warning' | 'failed' | 'pending'; label: string }> = {
  Proposed: { variant: 'warning', label: 'Proposed' },
  Approved: { variant: 'succeeded', label: 'Approved' },
  Rejected: { variant: 'failed', label: 'Rejected' },
  Deprecated: { variant: 'pending', label: 'Deprecated' },
}

interface GlossaryStatusBadgeProps {
  status: GlossaryTermStatus
}

export function GlossaryStatusBadge({ status }: GlossaryStatusBadgeProps) {
  const config = statusConfig[status]
  return <Badge variant={config.variant}>{config.label}</Badge>
}
